import React from "react";

export default function GuestLayout({children}) {
    return (
        <div className={`main-wrapper-content`}>
            <div className="main-content d-flex flex-column">
                {children}
            </div>
        </div>
    );
}
